export default __webpack_public_path__ + "static/media/dashboard.d057f3a5.svg";